import {Environment} from "../shared-api/helpers/Environment";
import {URLBuilder} from "../shared-api/helpers/URLBuilder";
import { getBackEndUrl } from '../fe-api/urls';

export class Endpoints {
    private static readonly ADDRESS_API = getBackEndUrl();
    private static readonly BASE_FE_CONTEXT = Environment.get("REACT_APP_BASE_FE_API");
    private static readonly BASE_API = URLBuilder.build(Endpoints.ADDRESS_API, {path: Endpoints.BASE_FE_CONTEXT});

    static readonly CDAS = URLBuilder.build(Endpoints.BASE_API, { path: "cdas"});
    static readonly RPVS = URLBuilder.build(Endpoints.BASE_API, { path: "rpvs"});
    static readonly AUTHENTICATIONS = URLBuilder.build(Endpoints.BASE_API, { path: "autenticacoes"});
    static readonly REMUNERACAO_DOWNLOAD = URLBuilder.build(Endpoints.BASE_API, { path: "documento-financeiro/download"});
    static readonly REMUNERACAO_UPLOAD = URLBuilder.build(Endpoints.BASE_API, { path: "documento-financeiro/upload"});
    static readonly REMUNERACAO_UPDATE = URLBuilder.build(Endpoints.BASE_API, { path: "documento-financeiro/atualizar"});
    static readonly REMUNERACAO_LISTAR = URLBuilder.build(Endpoints.BASE_API, { path: "documento-financeiro/listar"});
    static readonly REMUNERACAO_DELETE = URLBuilder.build(Endpoints.BASE_API, { path: "documento-financeiro/deletar"});
}